import React from 'react';
import { useTranslation } from 'react-i18next';
import FullBlockingModal from '../common/FullBlockingModal';
import { Button } from '../common/Button';
import { AdminReviewType } from '../../types/review';
import RatingStars from '../common/RatingStars';

interface ReviewModalActionsProps {
  review: AdminReviewType;
  onClose: () => void;
  onApprove: (review: AdminReviewType) => void;
  onReject: (review: AdminReviewType) => void;
}

const ReviewModalActions: React.FC<ReviewModalActionsProps> = ({
  review,
  onClose,
  onApprove,
  onReject,
}) => {
  const { t } = useTranslation(['common', 'reviews', 'admin']);

  return (
    <FullBlockingModal>
      <div className="p-2">
        <h3 className="text-xl font-bold mt-4 mb-2">
          {t('manage_review', { ns: 'admin', defaultValue: "Gestion de l'évaluation" })}
        </h3>

        <div className="border border-gray-300 rounded-lg p-4 mb-6">
          <div className="space-y-2">
            <p>
              <span className="font-semibold">
                {review.reviewer.first_name} {review.reviewer.last_name}
              </span>{' '}
              {t('has_reviewed', { ns: 'reviews' })}{' '}
              <span className="font-semibold">
                {review.reviewed.first_name} {review.reviewed.last_name}
              </span>
            </p>
            <div className="text-sm">
              {t('review', { ns: 'reviews' })}
              <RatingStars rating={review.rating} starClassName="w-4 h-4 md:w-3 md:h-3" />
            </div>
            {review.comment && (
              <p className="text-sm">
                <span className="font-semibold">{t('comment', { ns: 'reviews' })}:</span>{' '}
                {review.comment}
              </p>
            )}
          </div>
        </div>

        <div className="flex justify-center gap-3">
          <Button onClick={onClose} variant="transparent-with-border">
            {t('common:form_actions.close', { ns: 'common', defaultValue: 'Fermer' })}
          </Button>

          {!review.validated ? (
            <Button
              onClick={() => {
                onApprove(review);
                onClose();
              }}
              variant="primary"
            >
              {t('approve_review', { ns: 'reviews' })}
            </Button>
          ) : (
            <Button
              onClick={() => {
                onReject(review);
                onClose();
              }}
              variant="primary"
            >
              {t('cancel_review', { ns: 'reviews' })}
            </Button>
          )}
        </div>
      </div>
    </FullBlockingModal>
  );
};

export default ReviewModalActions;
